<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ACN_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="frame0.actionName"
              maxlength="50"
              @keyup.enter="onClickSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ACN_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="actionTypeCode"
              :selected="frame0.selectedCode.COD_TYPE"
              codeId="COD_ACN_TYPE"
              defaultOption="all"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_FNC_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="frame0.actionFunctionName"
              maxlength="50"
              @keyup.enter="onClickSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset "
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB10" />
      <!-- <div class="comm_title_wrap">
        <h4>액션 목록</h4>
      </div> -->
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsAction'"
        :multiselect="true"
        :hideHeader="true"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickClose"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickApply"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00001_P02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    actionMappingList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      frame0: {
        selectedCode: {
          COD_TYPE: {
            key: '',
            label: '',
          },
        },
        actionUid: '',
        actionName: '',
        dvoName: '',
        actionFunctionName: '',
      },
      localdata0: [],
      localdata1: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_ACN_NM'),
        datafield: 'actionName',
      }, {
        text: this.$t('MSG_TXT_ACN_TYPE'),
        datafield: 'actionTypeName',
      }, {
        text: this.$t('MSG_TXT_FNC_NM'),
        datafield: 'actionFunctionName',
      }],
      gridColumns1: [{
        text: this.$t('MSG_TXT_ACN_NM'),
        datafield: 'actionName',
      }, {
        text: this.$t('MSG_TXT_ACN_TYPE'),
        datafield: 'actionTypeName',
      }, {
        text: this.$t('MSG_TXT_FNC_NM'),
        datafield: 'actionFunctionName',
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    actionMappingList: {
      deep: true,
      handler() {
        this.dsActionMapping.setRawData(utils.clone(this.actionMappingList));
      },
    },
  },
  datasets: [{
    id: 'dsAction',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'actionUid', map: 'actionUid' },
      { type: 'string', name: 'actionName', map: 'actionName' },
      { type: 'string', name: 'actionTypeCode', map: 'actionTypeCode' },
      { type: 'string', name: 'actionTypeName', map: 'actionTypeName' },
      { type: 'string', name: 'actionExplanationContent', map: 'actionExplanationContent' },
      { type: 'string', name: 'actionFunctionName', map: 'actionFunctionName' },
      { type: 'string', name: 'dvoName', map: 'dvoName' },
      { type: 'string', name: 'springBeanId', map: 'springBeanId' },
      { type: 'string', name: 'actionUseYn', map: 'actionUseYn' },
      { type: 'string', name: 'actionUseYnName', map: 'actionUseYnName' }],
  }, {
    id: 'dsActionMapping',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { type: 'string', name: 'actionUid', map: 'actionUid' },
      { type: 'string', name: 'actionName', map: 'actionName' },
      { type: 'string', name: 'actionTypeCode', map: 'actionTypeCode' },
      { type: 'string', name: 'actionTypeName', map: 'actionTypeName' },
      { type: 'string', name: 'actionExplanationContent', map: 'actionExplanationContent' },
      { type: 'string', name: 'actionFunctionName', map: 'actionFunctionName' },
      { type: 'string', name: 'dvoName', map: 'dvoName' },
      { type: 'string', name: 'springBeanId', map: 'springBeanId' },
      { type: 'string', name: 'actionUseYn', map: 'actionUseYn' },
      { type: 'string', name: 'actionUseYnName', map: 'actionUseYnName' }],
  }],
  mounted() {
    this.dsActionMapping.setRawData(utils.clone(this.actionMappingList));
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onClickReset() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          this.$refs.actionTypeCode.reset();
        } else {
          this.frame0[key] = '';
        }
      });
    },
    onClickSearch() {
      const queryParams = {
        actionUid: '',
        actionName: this.frame0.actionName,
        actionTypeCode: this.frame0.selectedCode.COD_TYPE.key,
        actionFunctionName: this.frame0.actionFunctionName,
        dvoName: '',
      };

      http.request(this.pageId, 'DTS_CMR_00001', {
        query: queryParams,
      }).then(res => {
        this.dsAction.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    onClickApply() {
      const selectedData = this.dsAction.getSelectedRawData();
      if (selectedData.length !== 0) {
        this.$emit('paramReturn', selectedData, 'actionMappingList');
        this.$emit('onPopupClose');
      } else {
        // 선택 안했을 때
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onClickClose() {
      this.$emit('onPopupClose');
    },
  },
};
</script>
<style scoped>
</style>
